.title {
  margin-bottom: var(--dixa-size-spacer-200);
}

.explainer {
  color: var(--dixa-typography-color-tertiary);
  margin-bottom: var(--dixa-size-spacer-200);
}

.content {
  font-size: var(--dixa-typography-size-200);
  font-weight: var(--dixa-typography-weight-normal);
  line-height: var(--dixa-typography-line-height-200);
  height: 100%;
  overflow-y: auto;
}

.safeContent {
  width: 100%;
}

.actions {
  margin-top: var(--dixa-size-spacer-300);
}

.highlight {
  padding: 0 2px;
  font-style: normal;
  border-radius: var(--dixa-size-border-200);
  background: var(--dixa-color-purple-200);
}

.feedbackSent {
  line-height: var(--dixa-size-spacer-500);
}

.automation {
  margin-left: var(--dixa-size-spacer-100);
  margin-bottom: -1px;
  display: inline-block;
}
